/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Label_Needs_DetailInputs */

const en_wb_label_needs_detail = /** @type {(inputs: Wb_Label_Needs_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs a missing detail`)
};

const lv_wb_label_needs_detail = /** @type {(inputs: Wb_Label_Needs_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trūkst vienas detaļas`)
};

/**
* | output |
* | --- |
* | "Needs a missing detail" |
*
* @param {Wb_Label_Needs_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_label_needs_detail = /** @type {((inputs?: Wb_Label_Needs_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Label_Needs_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_label_needs_detail(inputs)
	return en_wb_label_needs_detail(inputs)
});